<script>

import Multiselect from 'vue-multiselect'

export default {
  components: { Multiselect },
  props: {

  },
  data(){
    return {
      trackBy: 'id',
      phone: null,
      firstName: null,
      middleName: null,
      lastName: null,
      variables: '{}',
      attempts: 1,
      time_retries: null,
      delayed: false,
      delayed_at: null,
      trunk: null,
      initTrunk: [],
      trunks_options: [],
    }
  },
  computed: {
    trunks_list_data(){
        return this.$store.getters['trunks/GET_TRUNKS_LIST_DATA'];
    },
  },
  async mounted() {
    await this.$store.dispatch('trunks/FETCH_TRUNKS_LIST', {'sortBy': 'id'});
    this.trunks_options = this.trunks_list_data;
  },
  methods: {
    save() {

      let status = this.delayed === false || this.delayed === '' ? 'created' : 'delayed'
      let trunk_id = this.trunk && this.trunk.id ? this.trunk.id : null;

      const {phone, firstName, middleName, lastName, variables, attempts, time_retries, delayed_at} = this
      this.$emit('save', {phone, firstName, middleName, lastName, variables, attempts, time_retries, delayed_at, status, trunk_id})
    
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>

<template>
  <div>
    <b-form class="form-horizontal" @submit.prevent="save">

      <b-form-group
        label="Транк"
        label-for="trunk"
    >
        <multiselect
            id="trunk"
            :track-by="trackBy"
            v-model="trunk"
            :options="trunks_options"
            placeholder="Выберите из списка"
            selectLabel="Нажмите, чтобы выбрать"
            deselectLabel="Нажмите, снять выделение"
            label="name"
        ></multiselect>
    </b-form-group>

      <b-form-group label="Номер телефона" label-for="call-phone">
        <b-form-input id="call-phone" v-model="phone" placeholder="Укажите номер телефона" />
      </b-form-group>

      <b-form-group label="Имя" label-for="call-first-name">
        <b-form-input id="call-first-name" v-model="firstName" placeholder="Укажите имя" />
      </b-form-group>

      <b-form-group label="Отчество" label-for="call-middle-name" >
        <b-form-input id="call-middle-name" v-model="middleName" placeholder="Укажите отчество" />
      </b-form-group>

      <b-form-group label="Фамилия" label-for="call-last-name" >
        <b-form-input id="call-last-name" v-model="lastName" placeholder="Укажите фамилию" />
      </b-form-group>

      <b-form-group
          label="JSON параметры"
          label-for="call-variables"
      >
        <b-form-textarea
            id="call-variables"
            v-model="variables"
            placeholder='{"var1" : "значение"};'
            rows="4"
        />
      </b-form-group>

      <div class="row">
        <div class="col-sm-12 col-xl-6">
            <b-form-group
                label="Попыток дозвона"
                label-for="attempts"
            >
                <b-form-input
                    id="attempts"
                    v-model="attempts"
                    placeholder="1"
                ></b-form-input>
            </b-form-group>
        </div>

        <div class="col-sm-12 col-xl-6">
            <b-form-group
                label="Время повторных звонков"
                label-for="time_retries"
            >
                <b-form-input
                    id="time_retries"
                    v-model="time_retries"
                    placeholder="1d 1h 10m"
                ></b-form-input>
            </b-form-group>
        </div>
    </div>

    <b-form-checkbox v-model="delayed" name="config_record" style="margin-top: 5px; margin-bottom: 15px" switch>
        Отложенный звонок
    </b-form-checkbox>

    <b-form-group
        v-if="delayed"
        label="Дата и время звонка"
        label-for="delayed_at"
    >
        <b-form-input
            id="delayed_at"
            v-model="delayed_at"
            placeholder="00:00:00 01.01.2022"
        ></b-form-input>
    </b-form-group>

      <hr style="margin-bottom: 0 !important;">

      <div class="btns-container" style="justify-content: flex-start; padding-left: 0px; padding-top: 25px">
        <button type="submit" class="btn btn-primary" style="margin-right: 7px"><i class="uil uil-play " style="margin-right: 3px"></i>Тестировать</button>
        <button type="button" class="btn btn-light" @click="close">Отменить</button>
      </div>
      
    </b-form>

  </div>
</template>

<style scoped>

.btns-container {
  padding: 0.75rem;
  display: flex;
  justify-content: flex-end;
}

</style>